<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_info">
            <tt-input ttLabel="p2_pofinish_keyno" [ttModel]="menu.p2_pofinish_keyno" ttReadonly></tt-input>
            <tt-input ttLabel="portal_user_name" [ttModel]="menu.portal_user_name" ttReadonly></tt-input>
            <tt-datetime ttLabel="reg_datetime" [ttModel]="menu.reg_datetime" ttReadonly></tt-datetime>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_functions">
            <tt-button-goto [ttText]="'products'" [ttGoto]="'pofinishprodlist'" [ttBadge]="menu.pofinishprodnbr" [ttGotoParms]="{ p2_pofinish_keyno: menu.p2_pofinish_keyno }"></tt-button-goto>
            <tt-button-goto [ttText]="'pickup_components'" [ttGoto]="'pofinishcomplist'" [ttGotoParms]="{ p2_pofinishprod_keyno: menu.p2_pofinishprod_keyno }"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>
